import React, { FunctionComponent, useEffect } from 'react';
import ErrorBoundaryState from 'app/components/mixins/ErrorBoundaryState';
import { notify } from 'app/services/errorReporter';

interface IProps {
  error?: Error;
  name?: string;
}

/**
 * Simple component for rendering an error if one is set.
 */
const ReportError = ({
  error,
  name = 'DiscreetErrorBoundary',
}: IProps) => {
  useEffect(() => {
    if (error) {
      notify(error, { name });
    }
  }, [error, name]);
  return null;
};

/**
 * Error Boundary for just reporting the error and not rendering anything.
 */
const DiscreetErrorBoundary: FunctionComponent<{
  name?: string;
}> = ({
  children,
  name,
}) => (
  <ErrorBoundaryState>{({ error }) =>
    error === undefined ? children : <ReportError name={name} error={error} />
  }</ErrorBoundaryState>
);

export default DiscreetErrorBoundary;
